import { z } from "zod";
import { AnnouncementCategory } from "../../../common/enums/announcement-category";

export const addAnnouncementSchema = z.object({
  title: z.string().min(1, { message: "Title is required" }).trim(),

  body: z.string().min(1, { message: "Body is required" }).trim(),

  date: z
    .string()
    .optional()
    .refine((date) => !date || !isNaN(Date.parse(date)), {
      message: "Invalid date format",
      path: ["date"],
    }),

  id: z
    .string()
    .optional(),

  category: z.number().optional(),
  announcementPhoto: z.any().optional(),
  createdByName: z.string().optional(),
  userPhotoUrl: z.string().optional(),
  lastUpdatedByName: z.string().optional(),
  lastUpdatedByPhotoUrl: z.string().optional()


});

export const defaultValues: z.infer<typeof addAnnouncementSchema> = {
  title: "",
  body: "",
  date: new Date().toISOString(),
  category: AnnouncementCategory.ProductUpdate,
  announcementPhoto: undefined,
};
export type AddAnnouncementSchema = z.infer<typeof addAnnouncementSchema>;
